import { NotificationType } from "./notification-type.enum";
import { Notification } from "./notification.model";

export class NotificationGroup {
    constructor(jsonObj: any = null) {
        if (jsonObj == null) {
          return;
        }
    
        this.license = jsonObj.license;
        this.accountNumber = jsonObj.accountNumber;
        this.type = jsonObj.type;

        this.notifications = jsonObj.notifications?.map((n: any) => new Notification(n)) ?? [];
      }
          
      license : string;
      accountNumber: number;
      type : NotificationType;
      notifications: Notification[];
}
    